module.exports = __webpack_public_path__ + "313a65630d341645c13e4f2a0364381d.woff";